import { playSound } from "./sounds";

// 🔔 Son d'une nouvelle demande de cours, pour le prof : une seule fois par demande, qu'elle arrive
// par le socket (App.js, « class-request ») ou à l'ouverture du tableau de bord (DashboardOne.js,
// demande en attente dans l'historique). Son « success » de helper/sounds.js, téléchargé au moment
// de le jouer.
const announced = new Set();

// play : lecture propre à l'appelant, sinon le son « success ». Renvoie false si cette demande a
// déjà sonné.
export const announceRequest = (classId, play = () => playSound("success")) => {
  const key = classId ? String(classId) : "";
  if (!key || announced.has(key)) return false;
  announced.add(key);
  play();
  return true;
};
